import { useLoadingStore } from '@/store/loading.store'
import { LoadingPulseSkeleton } from '@/components/common/LoadingSkeleton'
import { cn } from '@/utils/cn'

interface LoadingOverlayProps {
  /** Force visible regardless of global store */
  open?: boolean
  label?: string
  className?: string
  /** Use store-driven visibility (default) */
  useStore?: boolean
}

/** Full-surface loading veil for long operations */
export function LoadingOverlay({
  open,
  label = 'Loading…',
  className,
  useStore = true,
}: LoadingOverlayProps) {
  const storeLoading = useLoadingStore((s) => s.isLoading)
  const visible = open ?? (useStore ? storeLoading : false)

  if (!visible) return null

  return (
    <div
      className={cn(
        'fixed inset-0 z-[45] flex items-center justify-center bg-slate-900/35 backdrop-blur-[3px]',
        className,
      )}
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={label}
    >
      <LoadingPulseSkeleton />
    </div>
  )
}
